import { Draggable, Droppable } from '@hello-pangea/dnd'
import { Box, List, alpha, useTheme } from '@mui/material'
import { FC, ReactNode } from 'react'
import RenderBoardLink from './RenderBoardLink'

type BoardsTypes = {
  title: string
  _route?: string
  onNavigate?: () => void
  boardTheme: string
  icon: ReactNode
  disabled: boolean
  color?: string
  route?: string
}

interface BoardsNavDraggableProps {
  boards: BoardsTypes[]
  onNavigate: (route: string) => void
}

const BoardsNavDraggable: FC<BoardsNavDraggableProps> = ({ boards, onNavigate }) => {
  const theme = useTheme()
  return (
    <Droppable droppableId="boards">
      {provided => (
        <List {...provided.droppableProps} ref={provided.innerRef} sx={{ padding: 0 }}>
          {boards.map((board, index) => (
            <Draggable key={board.route} draggableId={board.route} index={index}>
              {(provided, snapshot) => (
                <Box
                  ref={provided.innerRef}
                  {...provided.draggableProps}
                  {...provided.dragHandleProps}
                  sx={{
                    borderRadius: 2,
                    backgroundColor: snapshot.isDragging ? alpha(theme.palette.text.primary, 0.1) : 'transparent',
                  }}
                >
                  <RenderBoardLink
                    title={board.title}
                    route={board.route}
                    onNavigate={() => onNavigate(board.route)}
                    boardTheme={board.color}
                    icon={board.icon}
                    disabled={board.disabled}
                  />
                </Box>
              )}
            </Draggable>
          ))}
          {provided.placeholder}
        </List>
      )}
    </Droppable>
  )
}

export default BoardsNavDraggable
